const getAriaAttributes = (props) => ({
    ...(props['aria-hidden'] ? { ['aria-hidden']: props['aria-hidden'] } : {}),
    ...(props['aria-label'] ? { ['aria-label']: props['aria-label'] } : {}),
    ...(props['aria-labelledby'] ? { ['aria-labelledby']: props['aria-labelledby'] } : {}),
});
const checkboxConfigurationPropsConversion = (props) => ({
    ...getAriaAttributes(props),
    checked: props.value,
    checkedIcon: { icon: 'icon_symbols_checkmark' },
    disabled: props.disabled,
    errorMessage: { content: props.error ? (props.helperMessage ?? '') : '' },
    helperText: { content: props.description ?? '' },
    label: { content: props?.title },
    onChange: props.onChange,
    screenReaderText: props?.screenReaderText,
    variant: props.variant,
});
export { checkboxConfigurationPropsConversion };
//# sourceMappingURL=checkbox.configurations.js.map